/**
 * rAF loop that pauses when the tab is hidden (battery respect — a virtual
 * pet should let the phone sleep). Elapsed time is game-local, not wall time.
 */
export interface LoopHandle {
  pause(): void;
  resume(): void;
  stop(): void;
}

export function startLoop(tick: (dt: number, elapsed: number) => void): LoopHandle {
  let raf = 0;
  let last = performance.now();
  let elapsed = 0;
  let running = false;
  let stopped = false;

  const frame = (now: number) => {
    const dt = Math.min(0.1, (now - last) / 1000);
    last = now;
    elapsed += dt;
    tick(dt, elapsed);
    raf = requestAnimationFrame(frame);
  };

  const resume = () => {
    if (running || stopped) return;
    running = true;
    last = performance.now();
    raf = requestAnimationFrame(frame);
  };
  const pause = () => {
    if (!running) return;
    running = false;
    cancelAnimationFrame(raf);
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pause();
    else resume();
  });

  resume();
  return {
    pause,
    resume,
    stop() {
      stopped = true;
      pause();
    },
  };
}
